import { Button, DestructiveButton } from "../buttons/Buttons";

type ConfirmationDialogButtonProps = {
  cancelLabel: React.ReactNode;
  confirmLabel: React.ReactNode;
  onConfirm: (confirmed: boolean) => void;
};

export const ConfirmationDialogButtons = ({ cancelLabel, confirmLabel, onConfirm }: ConfirmationDialogButtonProps) => {
  return (
    <>
      <Button
        action={(buttonActions) => {
          buttonActions?.focusVisible();
        }}
        autoFocus
        color="inherit"
        onClick={(event) => {
          event.stopPropagation();
          onConfirm(false);
        }}
        data-test="cancel-button"
      >
        {cancelLabel}
      </Button>

      <DestructiveButton
        onClick={(event) => {
          event.stopPropagation();
          onConfirm(true);
        }}
        data-test="confirm-button"
      >
        {confirmLabel}
      </DestructiveButton>
    </>
  );
};
